//=================================================
// Add to calendar component
//=================================================
import { google } from 'calendar-link';

const TIMEZONE = 'America/New_York';

// US Eastern DST rules (2nd Sunday of March → 1st Sunday of November) so calendars
// attach the event to Eastern time instead of UTC/GMT
const VTIMEZONE = [
    'BEGIN:VTIMEZONE',
    `TZID:${ TIMEZONE }`,
    'BEGIN:DAYLIGHT',
    'TZOFFSETFROM:-0500',
    'TZOFFSETTO:-0400',
    'TZNAME:EDT',
    'DTSTART:19700308T020000',
    'RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU',
    'END:DAYLIGHT',
    'BEGIN:STANDARD',
    'TZOFFSETFROM:-0400',
    'TZOFFSETTO:-0500',
    'TZNAME:EST',
    'DTSTART:19701101T020000',
    'RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU',
    'END:STANDARD',
    'END:VTIMEZONE',
];

// Local New York wall-clock time, e.g. 20261029T183000 (paired with TZID, so no trailing Z)
function icalDateFormat(dateString) {
    const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: TIMEZONE,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23',
    }).formatToParts(new Date(dateString));
    const part = (type) => parts.find((p) => p.type === type).value;
    return `${ part('year') }${ part('month') }${ part('day') }T${ part('hour') }${ part('minute') }${ part('second') }`;
}

// calendar-link's ical solution does not work on all devices
function downloadIcal(event) {
    const element = event.target;

    if (element.classList.contains('add-to-calendar__ical')) {
        const wrap = document.getElementById('add-to-calendar');
        const { dataset } = wrap;
        // encodeURIComponent so characters like # in titles/descriptions don't truncate the data URI
        const ics = `data:text/calendar;charset=utf8,${ encodeURIComponent([
            'BEGIN:VCALENDAR',
            'VERSION:2.0',
            ...VTIMEZONE,
            'BEGIN:VEVENT',
            `DTSTART;TZID=${ TIMEZONE }:${ icalDateFormat(dataset.start) }`,
            `DTEND;TZID=${ TIMEZONE }:${ icalDateFormat(dataset.end) }`,
            `SUMMARY:${ dataset.title }`,
            `DESCRIPTION:${ dataset.description }`,
            `LOCATION:${ dataset.location }`,
            'END:VEVENT',
            'END:VCALENDAR',
        ].join('\n')) }`;
        element.href = ics;
        element.download = 'event.ics';
    }
}

// insert the links that are generated by the calendar-link npm package
export function setupAddToCalendar() {
    const wrap = document.getElementById('add-to-calendar');
    if (!wrap) {
        return;
    }

    const event = { ...wrap.dataset };
    const googleEl = wrap.querySelector('.add-to-calendar__google');

    googleEl.setAttribute('href', google(event));

    document.addEventListener('click', downloadIcal);
}
